import { render, staticRenderFns } from "./pi-rate-time.vue?vue&type=template&id=1ff1a2de"
import script from "./pi-rate-time.vue?vue&type=script&lang=ts"
export * from "./pi-rate-time.vue?vue&type=script&lang=ts"
import style0 from "./pi-rate-time.vue?vue&type=style&index=0&id=1ff1a2de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports